
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class AddressRequestsState extends BaseYcState {

}
